import dayjs from 'dayjs';
import Image from 'components/FutureImage';
import { imageProxy } from 'tf-post-parser';
import VideoHeader from './VideoHeader';
import Link from 'next/link';
import Balancer from 'react-wrap-balancer';
import capitalize from 'helpers/capitalize';

export default function SimpleHeader({
  title,
  coverImage,
  createdAt,
  youtubeId,
  tags,
  author,
}) {
  return (
    <div
      className={
        'tw-w-full ' + (youtubeId ? ' tw-mb-8' : 'tw-mb-4 md:-tw-mb-4')
      }
    >
      <div className="sm:tw-text-center tw-mt-4 px-3">
        {tags && tags.length > 0 && (
          <p className="tw-text-sm tw-font-bold md:tw-text-base tw-text-primary-500">
            <Link href={`/topics/${tags[0]}`} className="hover:tw-underline">
              {capitalize(tags[0])}
            </Link>
          </p>
        )}
        <h1 className="sm:tw-mx-auto tw-break-normal tw-text-3xl tw-font-extrabold sm:tw-max-w-md md:tw-text-5xl lg:tw-max-w-xl xl:tw-max-w-3xl -tw-mt-2 tw-text-gray-800 dark:tw-text-gray-50">
          <Balancer>{title}</Balancer>
        </h1>
        <p className="tw-text-sm md:tw-text-sm tw-text-gray-500 tw-pt-4">
          {dayjs(createdAt).format('MMMM D, YYYY')} —{' '}
          <Link href={`/@${author.username}`} className="hover:tw-underline">
            {author.displayName}
          </Link>
        </p>
      </div>
      {youtubeId ? (
        <div className="tw-container tw-mx-auto tw-mt-8 tw-w-full tw-max-w-6xl tw-bg-primary-200 dark:tw-bg-primary-700 tw-rounded-xl">
          <VideoHeader youtubeId={youtubeId} />
        </div>
      ) : (
        <div
          className={
            'tw-container tw-mx-auto tw-mt-8 tw-h-56 tw-w-full tw-max-w-6xl tw-overflow-hidden tw-rounded-xl tw-bg-cover tw-shadow sm:tw-h-96 ' +
            (coverImage
              ? 'tw-bg-gray-800'
              : 'tw-bg-primary-200 dark:tw-bg-primary-700')
          }
        >
          <div className="tw-relative tw-h-full tw-w-full">
            {coverImage ? (
              <Image
                priority
                className="tw-object-cover tw-object-center"
                src={imageProxy(
                  coverImage.url,
                  2000,
                  800,
                  'cover',
                  undefined,
                  // true,
                )}
                alt={title}
                blurDataURL={coverImage.blur}
                placeholder={coverImage.blur ? 'blur' : undefined}
                fill
                sizes="(max-width: 680px) 100vw, (max-width: 1023px) 80vw, 62vw"
              />
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
